import React from 'react';
import './Hero.css';
import lunchBoxImage from '../assets/images/Entree/lunchBox.png';

function Hero() {
  const handleOrderNow = () => {
    const deliverySection = document.getElementById('delivery-partners');
    if (deliverySection) {
      deliverySection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section style={styles.heroSection} className="hero-section">
      <div style={styles.heroContainer} className="hero-container">
        <div style={styles.heroContent} className="hero-content">
          <p style={styles.welcomeText} className="welcome-text">Welcome to</p>
          <h1 style={styles.restaurantName} className="restaurant-name">
            <span style={styles.nameLine1}>Indo-Nepal</span>
            <span style={styles.nameLine2}>Culinary Fusion</span>
          </h1>
          <button style={styles.orderNowButton} className="order-now-button" onClick={handleOrderNow}>
            ORDER NOW
          </button>
          <div style={styles.lunchBoxSpecial} className="lunch-box-special">
            <p style={styles.specialTitle} className="special-title">TO GO LUNCH BOX SPECIAL</p>
            <p style={styles.specialDescription} className="special-description">
              Comes with Pilaf Rice, Yellow Lentil, Appetizer and Veg of the Day,
              Choice of Curry (Chicken/Paneer Butter Masala, Lamb/Paneer
              Bhuna or Shrimp/Paneer Madras), Chapati, Desert, and Bottled Water
            </p>
          </div>
        </div>
        <div style={styles.heroImage} className="hero-image">
          <div style={styles.lunchBoxContainer}>
            <img 
              src={lunchBoxImage} 
              alt="Lunch Box" 
              style={styles.lunchBoxImg}
              className="lunch-box-img"
              loading="eager"
              decoding="async"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;

const styles = {
  heroSection: {
    background: '#f5e6d3',
    padding: '4rem 2rem',
    minHeight: '400px',
    display: 'flex',
  },
  heroContainer: {
    maxWidth: '1400px',
    margin: '0 auto',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1rem',
  },
  heroContent: {
    textAlign: 'left',
    flex: 1,
    maxWidth: '600px',
  },
  heroImage: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  lunchBoxContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  lunchBoxImg: {
    maxWidth: '100%',
    maxHeight: '450px',
    width: 'auto',
    height: 'auto',
    objectFit: 'contain',
    transform: 'translateY(-95px) rotate(-4deg)',
    transition: 'transform 0.3s ease',
  },
  lunchBoxSpecial: {
    maxWidth: '500px',
    textAlign: 'left',
    padding: '1.5rem',
    marginTop: '1.5rem',
    background: 'rgba(255, 255, 255, 0.4)',
    borderRadius: '16px',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.1), 0 4px 8px rgba(0, 0, 0, 0.05)',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.3)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  },
  specialTitle: {
    fontSize: '1rem',
    fontWeight: 600,
    color: '#000000',
    marginBottom: '0.5rem',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    opacity: 0.9,
  },
  specialDescription: {
    fontSize: '0.85rem',
    color: '#2c2c2c',
    lineHeight: 1.6,
    margin: 0,
    opacity: 0.85,
  },
  welcomeText: {
    fontSize: '2.5rem',
    fontFamily: 'cursive, serif',
    color: '#000000',
    marginBottom: '0.5rem',
    marginLeft: 0,
    fontWeight: 400,
  },
  restaurantName: {
    fontFamily: '"Rubik", sans-serif',
    fontSize: '71px',
    fontWeight: 300,
    color: '#000000',
    lineHeight: 1.1,
    marginBottom: '2rem',
    display: 'flex',
    flexDirection: 'column',
    letterSpacing: '-1px',
  },
  nameLine1: {
    display: 'block',
  },
  nameLine2: {
    display: 'block',
  },
  orderNowButton: {
    background: '#FF1493',
    color: '#ffffff',
    border: 'none',
    padding: '1.25rem 3rem',
    fontSize: '1.1rem',
    fontWeight: 600,
    borderRadius: '50px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    boxShadow: '0 4px 12px rgba(255, 20, 147, 0.3)',
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
};

